import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class NoteModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: '',
            error: false
        };
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    onClose() {
        this.props.close();
        this.setState({
            text: '',
            error: false
        });
    }

    async onSave() {
        await this.props.save(this.state.text);
        if (this.props.success) {
            this.onClose();
        } else {
            this.setState({ error: true });
        }
    }

    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal warning-modal">
                        <div className="modal-header">
                            <h4 className="page-header">{this.props.note.noteId ? "Edit" : "New"} Note</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)} />
                        </div>
                        <textarea value={this.state.text ? this.state.text : this.props.note.text} name="text" onChange={this.onChange.bind(this)} />

                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose.bind(this)}>Cancel</button>
                                <button className="btn btn-primary" disabled={!this.state.text || this.state.text === this.props.note.text}
                                    onClick={this.onSave.bind(this)}>Save</button>
                                <FadeOutErrorMessage show={this.state.error} />
                            </div>}
                    </div>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/NoteModal.jsx